import colors from '../colors';

export default (color?: keyof typeof colors) => colors[color || 'white'] || '';
